/* eslint-disable no-alert */

AoPS.Utils.initKeyChain(AoPS, "Careers", "Models");

AoPS.Careers.Models = (function (Models) {
	Models.Utils = AoPS.Model.extend({
		handleAjaxError: function (data) {
			var flyout = false;
			var message;
			switch (data.error_code) {
				default:
					message =
						"Something unexpected happened.  If this continues to happen, please contact tech support.";
					if (data.error_msg) {
						message = data.error_msg;
					}
					break;
			}
			if (flyout && message) {
				AoPS.Ui.Flyout.queue(message);
			}
		},
		getRouter: function () {
			var master = this.master || {};
			return master.router || {};
		},
	});

	Models.Master = Models.Utils.extend({
		defaults: {
			jobBoard: null,
			search: null,
			currentPost: null,
		},
		initialize: function (options) {
			this.set("jobBoard", new Models.JobBoard({master: this}));
			this.on("change", this.handleChange);
		},
		handleChange: function (e) {
			if (
				e.changed.jobSlug ||
				(e.changed.viewName && e.changed.viewName === "JobPost")
			) {
				this.updateCurrentPost();
			}
		},
		updateCurrentPost: function (e) {
			var slug = this.get("jobSlug");
			var currentPost = this.get("currentPost");
			if (slug && (!currentPost || currentPost.get("postSlug") !== slug)) {
				var post = this.get("jobBoard").getJobBySlug(slug);
				if (post) {
					this.set("currentPost", post);
				} else if (this.get("viewName") === "JobPost") {
					this.set("viewName", "JobNotFound");
				}
			}
		},
		getViewModel: function () {
			switch (this.get("viewName")) {
				case "JobPost":
					return this.get("currentPost");
				default:
					return this.get("jobBoard");
			}
		},
	});

	Models.JobBoard = Models.Utils.extend({
		initialize: function (options) {
			this.master = options.master;
			var topWords = AoPS.bd.careersTop
				? JSON.parse(AoPS.bd.careersTop)
				: AoPS.bd.jobBoard.content;
			this.set("topWords", topWords);
			this.set("displayBy", "departments");
			this.initializeCollection("departments", Models.DepartmentCollection);
			this.initializeCollection("offices", Models.OfficeCollection);
			this.initializeCollection("jobs", Models.JobPostCollection);
			this.initializeFilters();
			this.setFilteredJobs();
		},
		initializeCollection: function (name, collectionModel) {
			var configObj = {
				master: this.master,
				jobBoard: this,
				collectionModel: collectionModel,
				name: name,
			};
			this.set(name, new collectionModel([], configObj));
			collectionModel = this.get(name);
			collectionModel.load();

			return collectionModel;
		},
		initializeFilters: function () {
			var filterList = [
				{
					key: "offices",
					defaultText: "All Locations",
					activeObjectIds: AoPS.bd.jobBoard.activeFilterIds.offices,
					doNotDisplayFilters: ["Multiple Locations"],
					alwaysIncludeFilters: [],
				},
				{
					key: "departments",
					defaultText: "All Departments",
					activeObjectIds: AoPS.bd.jobBoard.activeFilterIds.departments,
					doNotDisplayFilters: ["General Interest"],
					alwaysIncludeFilters: ["General Interest"], // always include general interest department in filter results
				},
			];

			var collection = this.initializeCollection(
				"filters",
				Models.FilterCollection
			);
			_.each(
				filterList,
				function (filterDef) {
					collection.add(new Models.Filter(filterDef, {jobBoard: this}));
				},
				this
			);
		},
		getFilteredJobs: function () {
			var ids = this.get("filters").getMatchedJobIds();
			return this.get("jobs").getFilteredCollection(ids);
		},
		getJobBySlug: function (slug) {
			return this.get("jobs").getJobBySlug(slug);
		},
		setFilteredJobs: function () {
			var filteredJobs = this.get("jobs").getFilteredCollection(
				this.get("filters").getMatchedJobIds()
			);

			this.set("filteredJobs", filteredJobs);
		},
	});

	Models.GrnhseObject = Models.Utils.extend({
		idAttribute: "id",
		initialize: function (_data, options) {
			this.options = options;
			this.master = options.master;
			this.jobBoard = options.jobBoard;
		},
	});

	/**
	 * Filter Model
	 * The "key" attribute determines what this filters on
	 * Example: departments, offices
	 */
	Models.Filter = Models.GrnhseObject.extend({
		idAttribute: "key",
		initialize: function (_data, options) {
			this.jobBoard = options.jobBoard;

			this.linkedCollection = this.jobBoard.get(this.get("key"));
			this.linkedCollection.linkFilter(this);

			this.set("selections", []);
			this.set("activeObjectIds", _data.activeObjectIds);
			this.set("doNotDisplayFilters", _data.doNotDisplayFilters);
			this.set(
				"alwaysIncludeFilterIds",
				this.getAlwaysIncludeFilterIds(_data.alwaysIncludeFilters)
			);
			this.set(
				"filterDisplayItems",
				this.getFilterDisplayItems(_data.activeObjectIds)
			);
		},
		/**
		 * Get a list of IDs to always include in filter selections
		 *
		 * @param {string[]} alwaysIncludeFilters
		 * @returns mixed[]
		 */
		getAlwaysIncludeFilterIds: function (alwaysIncludeFilters) {
			return _.pluck(
				this.linkedCollection.filter(function (el) {
					return alwaysIncludeFilters.indexOf(el.get("name")) >= 0;
				}),
				"id"
			);
		},
		/**
		 * Returns a unique list of relevant object IDs.
		 * Example: if this filters by office, will return all office
		 *   IDs attached to jobs.
		 */
		getActiveObjectIds: function () {
			return this.get("activeObjectIds");
		},
		getFilterDisplayItems: function (activeFilterIds) {
			return this.linkedCollection
				.getFilteredModelsAsCollection(activeFilterIds)
				.sortBy(function (el) {
					return el.getFilterText;
				})
				.map(function (el) {
					return {
						text: el.getFilterText(),
						value: el.get("id"),
					};
				})
				.filter(function (item) {
					return this.get("doNotDisplayFilters").indexOf(item.text) < 0;
				}, this);
		},
		updateFilter: function (selected) {
			this.set(
				"selections",
				_.union(
					_.pluck(selected, "value").map(function (value) {
						if (isNaN(value)) {
							return value;
						}
						return parseInt(value);
					}),
					this.get("alwaysIncludeFilterIds")
				)
			);
			this.jobBoard.setFilteredJobs();
		},
		getMatchedJobIds: function () {
			var matches = _.flatten(
				this.linkedCollection.getFilterMatches().map(
					_.bind(function (match) {
						return match.get("filterEquivalents").map(
							_.bind(function (id) {
								return this.linkedCollection.get(id);
							}, this)
						);
					}, this)
				)
			);

			return _.uniq(
				_.flatten(
					matches.map(function (match) {
						return match.getJobIds();
					}),
					this
				),
				this
			);
		},
	});

	Models.GrnhseGroup = Models.GrnhseObject.extend({
		getFilterValue: function () {
			return this.get("id");
		},
		getFilterText: function () {
			return this.get("name");
		},
		isFilterMatch: function (filterArr) {
			return filterArr.indexOf(this.getFilterValue()) >= 0;
		},
		getFilteredJobIdsForGroup: function () {
			var equivalentIds = this.get("filterEquivalents");
			var type = this.collection.options.name;
			var jobBoard = this.jobBoard;
			var filteredJobs = jobBoard.getFilteredJobs();
			return filteredJobs
				.filter(function (job) {
					var toMatch = job.get(type);
					var intersection = _.intersection(toMatch, equivalentIds);
					return intersection.length;
				})
				.map(function (job) {
					return job.get("id");
				});
		},
		getJobIds: function () {
			return this.get("jobs");
		},
		getJobsForGroup: function () {
			var jobBoard = this.jobBoard;
			var filteredJobs = jobBoard.getFilteredJobs();
			var filteredJobIdsForGroup = this.getFilteredJobIdsForGroup();

			return filteredJobs.getFilteredCollection(filteredJobIdsForGroup, true);
		},
	});

	Models.Office = Models.GrnhseGroup.extend({
		getFilterText: function () {
			return this.get("structuredLocation").display;
		},
		// offices don't come with job ids as an attr like
		// departments do.
		getJobIds: function () {
			return this.collection.jobBoard
				.get("jobs")
				.filter(function (job) {
					return job.get("offices").indexOf(this.get("id")) >= 0;
				}, this)
				.map(function (job) {
					return job.get("id");
				});
		},
	});

	Models.Department = Models.GrnhseGroup.extend({});

	Models.JobPost = Models.GrnhseObject.extend({
		getPrimaryAssociation: function (type) {
			var primaryId = this.get(type)[0];
			return this.collection.jobBoard.get(type).get(primaryId);
		},
		getRemoteTag: function () {
			var office = this.getPrimaryAssociation("offices");
			if (!office) {
				return false;
			}
			var isFullyRemote = (office.get("location") || "").indexOf("Remote") >= 0;
			if (isFullyRemote) {
				return "Remote";
			}
			if (this.get("metadata").open_to_remote) {
				return "Open To Remote";
			}
			return false;
		},
		getTimeStatus: function () {
			return this.get("metadata").display_employment_type;
		},
		getPrimaryOfficeLocation: function () {
			var offices = this.get("offices");
			if (offices.length > 1) {
				return "Multiple";
			}

			return this.collection.jobBoard
				.get("offices")
				.get(offices[0])
				.get("structuredLocation").display;
		},
		getUrlPath: function () {
			var base = this.getRouter().getUrlBase();
			return base + "/job/" + this.get("postSlug");
		},
	});

	Models.GrnhseCollection = Backbone.Collection.extend({
		initialize: function (_models, options) {
			this.canLoad = true;
			this.options = options;
			this.master = options.master;
			this.jobBoard = options.jobBoard;
			this.collectionModel = options.collectionModel;
		},
		load: function () {
			if (this.canLoad) {
				this.add(_.values((AoPS.bd.jobBoard || {})[this.dataKey] || {}), {
					master: this.master,
					jobBoard: this.jobBoard,
				});
			}
		},
	});

	Models.FilterCollection = Models.GrnhseCollection.extend({
		model: Models.Filter,
		canLoad: false,
		getMatchedJobIds: function () {
			var matches = null;
			for (var i = 0; i < this.models.length; i++) {
				var matched = this.models[i].getMatchedJobIds();
				if (!matched) {
					// if at any point we get an empty result
					// we can stop because there's no way to
					// get an intersection with nothing.
					return [];
				}
				if (i === 0) {
					matches = matched;
				} else {
					matches = _.intersection(matches, matched);
					if (!matches.length) {
						// empty set, no possible results
						return [];
					}
				}
			}

			return matches;
		},
	});

	Models.JobPostCollection = Models.GrnhseCollection.extend({
		model: Models.JobPost,
		dataKey: "jobs",
		getFilteredCollection: function (ids, collapse = false) {
			var found = [];
			return new this.collectionModel(
				this.filter(function (job) {
					var id = job.get("id");
					if (ids.indexOf(id) >= 0) {
						if (collapse) {
							var equivalents = job.get("filterEquivalents");
							if (!equivalents.length) {
								equivalents = [id];
							}

							if (found.indexOf(id) < 0) {
								job.set(
									"filteredEquivalents",
									_.intersection(equivalents, ids)
								);
								found = found.concat(equivalents);
								return true;
							}
							return false;
						}
						return true;
					}
					return false;
				}),
				this.options
			);
		},
		getJobBySlug: function (slug) {
			return this.findWhere({postSlug: slug});
		},
	});

	/**
	 * Group Collection Model
	 * A collection of "groups"
	 * Example: offices, departments
	 */
	Models.GroupCollection = Models.GrnhseCollection.extend({
		comparator: "name",
		/**
		 * Link an instance of Models.Filter
		 * to this collection
		 */
		linkFilter: function (filter) {
			this.linkedFilter = filter;
		},
		/**
		 * Returns a filtered collection of group objects that have
		 * at least one matching job post.
		 *
		 * Example: if this is an offices collection, this function will return
		 *   all offices that have open jobs.
		 */
		getActive: function () {
			return this.getFilteredModelsAsCollection(
				this.linkedFilter.getActiveObjectIds()
			);
		},
		/**
		 * Returns a set of models where the model ID is in
		 * the set of filterIds
		 */
		getFilteredModels: function (filterIds) {
			if (!filterIds.length) {
				// if no filters, return all
				return this;
			}

			var filtered = this.models.filter(function (model) {
				return model.isFilterMatch(filterIds);
			});
			return filtered;
		},
		/**
		 * Returns a filtered copy of this collection based on a list of
		 * filterIds.
		 * Calls getFilteredModels under the hood
		 */
		getFilteredModelsAsCollection: function (filterIds) {
			if (!filterIds || !filterIds.length) {
				return this;
			}

			var options = _.clone(this.options);
			options.filtered = true;
			var newCollection = new this.collectionModel(
				this.getFilteredModels(filterIds),
				options
			);
			if (this.linkedFilter) {
				newCollection.linkFilter(this.linkedFilter);
			}
			return newCollection;
		},
		/**
		 * Returns a filtered collection of objects that match
		 * the currently selected options on the linked filter.
		 * Example: if this is a departments collection, it will
		 *   return all departments that match the selected department(s)
		 *
		 * Returns all available selections if nothing is selected.
		 */
		getFilterMatches: function () {
			var linkedFilterSelections = this.linkedFilter.get("selections");
			if (!linkedFilterSelections.length) {
				linkedFilterSelections = this.linkedFilter.get("activeObjectIds");
			}

			return this.getFilteredModelsAsCollection(linkedFilterSelections);
		},
		/**
		 * Returns a collection of group objects that should show based
		 * on the current filter settings.
		 */
		getActiveGroups: function () {
			var active = this.getActive();
			var filtered = this.getFilterMatches();
			if (active.length < filtered.length) {
				return active;
			}

			return this.getFilteredModelsAsCollection(
				filtered
					.filter(function (group) {
						if (group.getJobsForGroup().length) {
							return true;
						}
					})
					.map(function (group) {
						return group.get("id");
					})
			);
		},
	});

	Models.OfficeCollection = Models.GroupCollection.extend({
		model: Models.Office,
		dataKey: "offices",
	});

	Models.DepartmentCollection = Models.GroupCollection.extend({
		model: Models.Department,
		dataKey: "departments",
		/**
		 * Get string to sort on.  Returns
		 * "name" unless this is the "General Interest"
		 * department, in which case return a string of z's
		 * so that it sorts to the bottom of the list.
		 *
		 * @param {Models.Department} el
		 * @returns String
		 */
		comparator: function (el) {
			var name = el.get("name");
			if (name === "General Interest") {
				return "zzzzzzz";
			}
			return name;
		},
	});

	return Models;
})(AoPS.Careers.Models || {});
